import { VueConstructor } from 'vue/types/umd';

export const install = (Vue: any, components: Array<VueConstructor>) => {
  components.forEach((comp) => {
    Vue.component(comp.name, comp);
  });
};
